<template>
  <div>
    <span>{{$util.formatDur2(startTime)}}</span>
    <span>-</span>
    <span>{{$util.formatDur2(startTime+cutDuration)}}</span>
    <span>/</span>
    <span>{{$util.formatDur2(duration)}}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    startTime: {
      type: Number,
      default: 0
    },
    cutDuration: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectSprites_Msg'
    ])
  },
  components: {

  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/popups/content/videoSpriteDuration.vue